import type { CareGapModel } from '@ctw/shared/api/fhir/models/care-gap';
import type { BadgeProps } from '@ctw/shared/components/badge';
import { faBan, faClock, faFileExcel, faStar } from '@fortawesome/pro-regular-svg-icons';

export const careGapStatusBadgeDefinition = (gap: CareGapModel): BadgeProps => {
  if (gap.status.slug === 'closed') {
    return {
      variant: 'primary',
      content: gap.status.label,
      icon: faStar,
      testId: 'care-gap-badge-closed',
    };
  }

  if (gap.status.slug === 'excluded') {
    return {
      variant: 'meta',
      content: gap.status.label,
      icon: faBan,
      testId: 'care-gap-badge-excluded',
    };
  }

  if (gap.status.slug === 'not-met') {
    return {
      variant: 'meta',
      content: gap.status.label,
      icon: faFileExcel,
      testId: 'care-gap-badge-not-met',
    };
  }

  if (gap.status.slug === 'pending') {
    return {
      variant: 'info',
      content: gap.status.label,
      icon: faClock,
      testId: 'care-gap-badge-pending',
    };
  }

  return {
    variant: 'info',
    content: gap.status.label,
    icon: faClock,
    testId: 'care-gap-badge-open',
  };
};
